export class Voc {
  constructor(
    public readonly id: string,
    public readonly categoryPath: string,
    public readonly recordedAt: Date,
    public readonly vocText: string,
    public readonly extraAttributes?: Record<string, string | number> | null,
  ) {}
}
